export default function useArrayLength(array) {
    return array?.length > 0
}